import React from "react";
import { User, LogOut, LayoutDashboard, ShieldCheck, Flame } from "lucide-react";

export default function Navbar({ user, onOpenAuth, onLogout, onNavigate, onStartFunnel }) {
  return (
    <header className="sticky top-0 z-50 bg-black/90 backdrop-blur-xl border-b border-neutral-800 text-white font-manrope">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Brand Logo & Name */}
        <button
          onClick={() => onNavigate("home")}
          className="flex items-center gap-3 group focus:outline-none"
          data-testid="brand-logo-button"
        >
          <img
            src="/assets/ssa-logo-white.png"
            alt="ForgedByStokes"
            className="h-14 w-auto group-hover:opacity-80 transition-opacity duration-300"
          />
        </button>

        {/* Navigation Links */}
        <nav className="hidden md:flex items-center gap-8 text-sm uppercase tracking-widest text-neutral-300">
          <button
            onClick={() => onNavigate("home")}
            className="hover:text-white transition-colors py-2 focus:outline-none"
            data-testid="nav-home"
          >
            Mission
          </button>
          <button
            onClick={() => onNavigate("programs")}
            className="hover:text-white transition-colors py-2 focus:outline-none"
            data-testid="nav-programs"
          >
            Programs
          </button>
          <button
            onClick={() => onNavigate("coaching")}
            className="hover:text-white transition-colors py-2 focus:outline-none"
            data-testid="nav-coaching"
          >
            Coaching
          </button>
          <button
            onClick={() => onNavigate("meals")}
            className="hover:text-white transition-colors py-2 focus:outline-none"
            data-testid="nav-meals"
          >
            Meal Plans
          </button>
          <button
            onClick={() => onNavigate("prayer-wall")}
            className="hover:text-white transition-colors py-2 focus:outline-none"
            data-testid="nav-prayer"
          >
            Prayer Wall
          </button>
        </nav>

        {/* User Portal Action */}
        <div className="flex items-center gap-4">
          <button
            onClick={onStartFunnel}
            className="hidden lg:flex items-center gap-2 border border-white text-white px-4 py-2 text-xs uppercase tracking-widest font-bold hover:bg-white hover:text-black transition-all duration-300 focus:outline-none"
            data-testid="nav-apply-button"
          >
            <Flame className="w-4 h-4" />
            <span>Apply To Train</span>
          </button>
          {user ? (
            <div className="flex items-center gap-3">
              <button
                onClick={() => onNavigate("dashboard")}
                className="flex items-center gap-2 border border-white bg-transparent text-white px-4 py-2 text-xs uppercase tracking-widest font-semibold hover:bg-white hover:text-black transition-all duration-300 focus:outline-none"
                data-testid="dashboard-link"
              >
                {user.role === "admin" ? (
                  <ShieldCheck className="w-4 h-4" />
                ) : (
                  <LayoutDashboard className="w-4 h-4" />
                )}
                <span>My Temple</span>
              </button>
              
              <button
                onClick={onLogout}
                className="border border-neutral-800 bg-transparent text-neutral-400 p-2 hover:text-white hover:border-neutral-500 transition-all focus:outline-none"
                data-testid="logout-button"
                title="Log Out"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          ) : (
            <button
              onClick={onOpenAuth}
              className="flex items-center gap-2 bg-white text-black px-5 py-2 text-xs uppercase tracking-widest font-bold hover:bg-neutral-200 transition-all duration-300 focus:outline-none"
              data-testid="login-button"
            >
              <User className="w-4 h-4" />
              <span>Portal Login</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
